import { HttpAddParticipantService } from './http-add-participant.service';
import { ParticipantDTO } from 'app/core/models/participant-dto';
import { catchError, map, Observable, throwError } from 'rxjs';
import { Participant } from 'app/core/models/participant';
import { Injectable } from '@angular/core';

@Injectable({
  	providedIn: 'root'
})

export class AddParticipantService {

  	constructor(
		private httpAddParticipantService: HttpAddParticipantService
	) { }

	public addParticipant$(
		newParticipantID: string,
        newParticipantName: string,
        newParticipantTargetURL: string,
        newParticipantProtocols: string[]
	): Observable<Participant> {

		return this.httpAddParticipantService.addParticipant$(
			newParticipantID,
			newParticipantName,
			newParticipantTargetURL,
			newParticipantProtocols
		).pipe(
			map((dto: ParticipantDTO) => Participant.createFromDTO(dto)),
			catchError(err => {
				console.error('[AddParticipantService] Error adding the new participant', err);
				return throwError(() => new Error('An error has occurred while trying to add the new participant'));
			})
		);

	}

}